import { atom } from 'recoil';
import { UsersDataTypes } from '../types/users.schema';

export const userAuthDetails = atom({
  key: 'userState',
  default: null as UsersDataTypes | null,
});
